import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMaxLength]',
})
export class MaxLengthDirective {
  @Input() maxLength: number;
  @Input() allowDecimals = false;
  @Input() allowChars = false;
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement) {
    const value = input.value;
    const maxLength = this.maxLength || (this.allowDecimals ? 10 : 5); // Si permite decimales, máximo 10 caracteres, si no, máximo 5 caracteres
    const pattern = this.allowChars
      ? /^[\s\S]*$/
      : this.allowDecimals
      ? /^[0-9]*(\.[0-9]{0,2})?$/
      : /^[0-9]*$/; // Expresión regular que permite decimales si allowDecimals es true
    if (value.length > maxLength || !pattern.test(value)) {
      let newValue = value;
      if (pattern.test(value)) {
        newValue = value.slice(0, maxLength);
      } else {
        newValue = newValue.slice(0, -1);
      }
      // const newValue =  ? value.substr(0, maxLength) : ''; // Si el valor no es válido, se limpia el input
      this.ngControl.control.setValue(newValue);
    }
  }
}
